module.exports = __webpack_public_path__ + "img/SCFSLabel.8b3794f0.png";